// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the TenantSelectionStep component */

/* Scrollable tenant list container */
.ts-tenant-list {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}

/* Individual tenant row */
.ts-tenant-row {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  gap: 12px;
}

/* Tenant name and status wrapper */
.ts-tenant-info {
  flex: 1;
}

/* Tenant display name */
.ts-tenant-name {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 2px;
}

/* Deployed rules count */
.ts-tenant-status {
  font-size: 12px;
  color: #6b7280;
}

/* Base deployment badge */
.ts-badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
}

.ts-badge--deployed {
  background: #e6f4ea;
  color: #1e8e3e;
}

.ts-badge--partial {
  background: #fff4ce;
  color: #8a6914;
}

.ts-badge--not-deployed {
  background: #f3f2f1;
  color: #605e5c;
}

/* Footer row */
.ts-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e5e5e5;
}

/* Intro description text */
.ts-intro-text {
  display: block;
  margin-bottom: 16px;
  color: #6b7280;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/policies/deploymentWizard/TenantSelectionStep.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD,qCAAqC;AACrC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,OAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* Styles for the TenantSelectionStep component */\n\n/* Scrollable tenant list container */\n.ts-tenant-list {\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n/* Individual tenant row */\n.ts-tenant-row {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #f0f0f0;\n  gap: 12px;\n}\n\n/* Tenant name and status wrapper */\n.ts-tenant-info {\n  flex: 1;\n}\n\n/* Tenant display name */\n.ts-tenant-name {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 2px;\n}\n\n/* Deployed rules count */\n.ts-tenant-status {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n/* Base deployment badge */\n.ts-badge {\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.ts-badge--deployed {\n  background: #e6f4ea;\n  color: #1e8e3e;\n}\n\n.ts-badge--partial {\n  background: #fff4ce;\n  color: #8a6914;\n}\n\n.ts-badge--not-deployed {\n  background: #f3f2f1;\n  color: #605e5c;\n}\n\n/* Footer row */\n.ts-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 24px;\n  padding-top: 16px;\n  border-top: 1px solid #e5e5e5;\n}\n\n/* Intro description text */\n.ts-intro-text {\n  display: block;\n  margin-bottom: 16px;\n  color: #6b7280;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
